import './App.css'
import { AvatarEditor } from './AvatarEditor'

function App() {
    return (
        <div className="App">
            <AvatarEditor />
        </div>
    )
}

export default App
